/**
 * author: bing
 * Date: 2017/12/26
 * Time: pm 15:30
 *
 */

import axios from 'axios'
import config from '../com/config'
// import qs from 'qs'

// 引入饿了么的弹框
import { Message, MessageBox } from 'element-ui'

class Axios {
  constructor (url) {
    this.init(url)
  }

/**
 * 初始化
 */
  init (url) {
    axios.defaults.baseURL = config.host // defaults.baseURL
    axios.defaults.withCredentials = true
  }

 /**
 * 判断是否是登录(根据token)
 * @param
 * @returns {boolean}
 * @private
 */
  isLogin () {
    let token = this.getQueryString('token') || localStorage.getItem('Haiziguo-Token')
    if (token && token.length > 0) {
      axios.defaults.headers = { 'Haiziguo-Token': token }
      return true
    } else {
      return false
    }
  }
  getQueryString (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var url = window.location.href.split('?')[1]
    if (url === undefined) {
      return false
    }
    var r = url.match(reg)
    if (r != null) { return decodeURI(r[2]) }
    return null
  }

  /**
 * 判断是否返回数据
 * @param data 接收到的数据
 * @returns {boolean}
 * @private
 */
  isStatus (data) {
    if (data && data.success) {
      return true
    } else {
      Message.error(data.message)
      return false
    }
  }

/**
 * 全局错误处理
 * @param data 传入错误的数据
 * @private
 */
  error (data) {
    // Message.error(data.data.msg || '网络错误！')
    if (data.response && data.response.status === 911) {
      MessageBox.alert('登录超时,请重新登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          window.top.location.href = './login.html'
        }
      })
      // Message.error('登录超时,请重新登录')
    } else {
      let msg = data.data ? data.data.msg : '网络错误'
      Message.error(msg)
    }
  }

/**
 * GET 请求
 * @param url String 地址信息
 * @param data Object 需要发送的参数
 * @returns {Promise}
 * @constructor
 */
  get (url, data) {
    // 创建一个promise对象
    // this.isLogin()
    if (this.isLogin()) {
      this.promise = new Promise((resolve, reject) => {
        axios.get(url, { params: data }).then((data) => {
          if (this.isStatus(data.data)) {
            resolve(data.data)
          }
        }).catch((data) => {
          this.error(data)
          resolve(data.data)
        })
      })
    } else {
      MessageBox.alert('登录超时,请重新登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          window.top.location.href = './login.html'
        }
      })
      return
    }
    return this.promise
  };

  /**
   * POST 请求
   * @param url String url地址信息
   * @param data Object 需要发送的参数
   * @returns {Promise}
   * @constructor
   */
  post (url, params, noToken) {
    // 判断是否加头部
    if (this.isLogin() || noToken) {
    // 创建一个promise对象
      this.promise = new Promise((resolve, reject) => {
        axios.post(url, params)
          .then((data) => {
              // 是否请求成功
            if (this.isStatus(data.data)) {
            //   // // 是否需要存数据
            //   // if (this.isLogin()) {
            //   // this.setUserInfo(data.data)
            //   // };
            //   // return data
              resolve(data.data)
            };
          })
          .catch((data) => {
            this.error(data)
            resolve(data.data)
          })
      })
    } else {
      MessageBox.alert('登录超时,请重新登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          window.top.location.href = './login.html'
        }
      })
      return
    }
    return this.promise
  };
};

/***
 * =========================拦截器部分==============================
 */

    // POST传参序列化(请求拦截器)
axios.interceptors.request.use((config) => {
  // 在发送请求之前做某件事
  // if (config.method === 'post') {
    // config.data = qs.stringify(config.data)
  // }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 返回状态判断(响应拦截器)
axios.interceptors.response.use((res) => {
  // 对响应数据进行token的处理
  if (res.data.success) {
    localStorage.setItem('Haiziguo-Token', res.headers['haiziguo-token'])
    return res
  } else {
    return Promise.reject(res)
  }
}, (error) => {
  return Promise.reject(error)
})

export default new Axios()



// WEBPACK FOOTER //
// ./src/com/ajax.js